import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "catalog-item-actions" };
const _hoisted_2 = {
    key: 0,
    class: "catalog-item-actions__param"
};
const _hoisted_3 = { class: "catalog-item-actions__variants" };
const _hoisted_4 = { class: "catalog-item-actions__variant-name" };
const _hoisted_5 = {
    key: 0,
    class: "catalog-item-actions__variants-dropdown"
};
const _hoisted_6 = ["onClick"];
import { ref, watch } from 'vue';
import ArticleCartForm from "./ArticleCartForm.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogItemActions2',
    props: {
        product: {},
        selectedVariant: {},
        cart: {},
        addCartItems: { type: Function },
        addWatchlistItem: { type: Function },
        allowOrderingUnitSelection: { type: Boolean }
    },
    emits: ['cart-item-draft-change'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const variant = ref(props.selectedVariant ? props.selectedVariant : props.product.variants[0]);
        const sku = ref(variant.value.sku);
        const showVariantsDropdown = ref(false);
        watch(() => sku.value, onSkuChange);
        function onSkuChange() {
            let variantLocal;
            if (props.product) {
                variantLocal = props.product.variants.find(v => v.sku === sku.value);
            }
            if (variantLocal === undefined) {
                sku.value = variant.value.sku;
                return;
            }
            variant.value = variantLocal;
        }
        function selectVariant(variant) {
            sku.value = variant.sku;
            showVariantsDropdown.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.product && __props.product.variants.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                                class: "catalog-item-actions__variant-selected",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (showVariantsDropdown.value = !showVariantsDropdown.value), ["prevent"]))
                            }, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(variant.value.name || variant.value.sku), 1),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createVNode(Icon, { name: "caret-down" })
                            ]),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            (showVariantsDropdown.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.variants, (v) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                            key: v.sku,
                                            class: "catalog-item-actions__variant",
                                            href: "",
                                            onClick: _withModifiers(($event) => (selectVariant(v)), ["prevent"])
                                        }, _toDisplayString(v.name || v.sku), 9, _hoisted_6));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                (variant.value && variant.value.price)
                    ? (_openBlock(), _createBlock(ArticleCartForm, {
                        key: 1,
                        variant: variant.value,
                        cart: __props.cart,
                        "add-cart-items": __props.addCartItems,
                        "add-watchlist-item": __props.addWatchlistItem,
                        "allow-ordering-unit-selection": __props.allowOrderingUnitSelection,
                        onCartItemDraftChange: _cache[1] || (_cache[1] = ($event) => (emit('cart-item-draft-change', $event)))
                    }, null, 8, ["variant", "cart", "add-cart-items", "add-watchlist-item", "allow-ordering-unit-selection"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
